import styled from "@emotion/styled";
import { ListItemButton, Drawer as MuiDrawer } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import useCompanyLogoQuery from "../../hooks/graphql-hooks/queries/useCompanyLogoQuery";
import LoadingCircle from "../loadingCircle/LoadingCircle";
import "./Sidebar.scss";
import SidebarNav from "./SidebarNav";

const asysIcon = require("../../assets/images/Arvato_Systems_Logo.png");

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Brand = styled(ListItemButton)`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.sidebar.header.color};
  background-color: ${(props) => props.theme.sidebar.header.background};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${(props) => props.theme.spacing(6)};
  padding-right: ${(props) => props.theme.spacing(6)};
  justify-content: center;
  cursor: pointer;
  flex-grow: 0;

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.header.background};
  }
`;

export type SidebarProps = {
  PaperProps: {
    style: {
      width: number;
    };
  };
  variant?: "permanent" | "persistent" | "temporary";
  open?: boolean;
  onClose?: () => void;
  showFooter?: boolean;
  authorized: boolean;
};

const Sidebar: React.FC<SidebarProps> = ({
  showFooter = true,
  authorized,
  ...rest
}) => {
  const navigate = useNavigate();
  const [companyLogo, setCompanyLogo] = useState(asysIcon);

  const { loading } = useCompanyLogoQuery({
    skip: !authorized,
    dataAction: (url) => {
      setCompanyLogo(url || asysIcon);
    },
    errorAction: () => {
      setCompanyLogo(asysIcon);
    },
  });

  return (
    <Drawer variant="permanent" {...rest}>
      <Brand
        onClick={() => navigate("/home", { state: { refreshAt: Date.now() } })}
      >
        {!loading ? (
          <img
            className="sidebar-brand-icon"
            src={companyLogo || asysIcon}
            alt="Company Logo"
          />
        ) : (
          <LoadingCircle className="mr-10" size={24} />
        )}
      </Brand>
      <SidebarNav authorized={authorized} />
    </Drawer>
  );
};

export default Sidebar;
